<app-collapsible-section
  [header]="emailSectionHeader"
  [body]="emailSectionBody"
  [isInitiallyCollapsed]="true"
  [backgroundVariant]="'light-secondary'"
></app-collapsible-section>

<ng-template #emailSectionHeader>
  <ipo-text [weight]="'bold'"> {{ 'contactUsHeader' | translate }}</ipo-text>
</ng-template>
<ng-template #emailSectionBody>
  <div class="email-container" id="cr-email-section">
    <ipo-text>{{ 'emailHeaderDescription' | translate }}</ipo-text>
    <div class="email-container_dropdowns">
      <ipo-dropdown
        [options]="
          emailsSubjectOptionsList
            | translateArray: (language$ | async)! : 'label'
        "
        [selected]="selectedEmailSubject"
        [placeholder]="'emailSubjectPlaceholder' | translate"
        (changed)="addSelectedOption($event, true)"
        [label]="'emailSubjectTitle' | translate"
        [fullWidth]="true"
      >
      </ipo-dropdown>

      <ipo-dropdown
        [options]="
          emailAppOptions | translateArray: (language$ | async)! : 'label'
        "
        [selected]="selecteEmailApp"
        [placeholder]="'emailAppPlaceholder' | translate"
        (changed)="addSelectedOption($event, false)"
        [label]="'emailAppTitle' | translate"
        [fullWidth]="true"
      >
      </ipo-dropdown>
    </div>

    <ipo-input
      class="width-full"
      [renderTextArea]="true"
      [clearInput]="true"
      (changed)="setEmailBody($event)"
      [value]="emailBody"
      [label]="'emailContent' | translate"
    ></ipo-input>

    <ipo-button
      (click)="createEmailTemplate()"
      (keydown.enter)="createEmailTemplate()"
      [type]="'primary'"
      [disabled]="!selecteEmailApp || !selectedEmailSubject"
      class="submit-email-button"
      [size]="'full'"
      >{{ 'emailCreateButton' | translate }}</ipo-button
    >
  </div>
</ng-template>
